import ErrorIcon from "@mui/icons-material/Error";
import Stack from "@mui/material/Stack";
import { tokens } from "styles/Tokens";
import Typography from "./Typography";

const ErrorPage = () => {
  return (
    <Stack
      alignItems="center"
      spacing={2}
      justifyContent="center"
      sx={{ height: "100vh", width: "100%", padding: "16px" }}
    >
      <ErrorIcon sx={{ fontSize: "48px", color: tokens.Text.Feedback.Alert }} />
      <Typography variant="h5" showBold color={tokens.Text.General.PrimaryHeadline}>
        Something went wrong!
      </Typography>
      <Typography variant="body2" color={tokens.Text.General.Tertiary}>
        There was a problem processing the request. Please try refresh.
      </Typography>
    </Stack>
  );
};

export default ErrorPage;
